/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ChecklistQualitativeAnswerTypeDTO model module.
 * @module model/ChecklistQualitativeAnswerTypeDTO
 * @version v0
 */
export class ChecklistQualitativeAnswerTypeDTO {
  /**
   * Constructs a new <code>ChecklistQualitativeAnswerTypeDTO</code>.
   * @alias module:model/ChecklistQualitativeAnswerTypeDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistQualitativeAnswerTypeDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistQualitativeAnswerTypeDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistQualitativeAnswerTypeDTO} The populated <code>ChecklistQualitativeAnswerTypeDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistQualitativeAnswerTypeDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('answer'))
        obj.answer = ApiClient.convertToType(data['answer'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistQualitativeAnswerTypeDTO.prototype.id = undefined;

/**
 * @member {String} answer
 */
ChecklistQualitativeAnswerTypeDTO.prototype.answer = undefined;

